import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "25",
  height: "24",
  viewBox: "0 0 25 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "M12.57 21.98C11.16 21.98 9.73997 21.44 8.66997 20.37L4.13997 15.84C3.03997 14.74 2.45997 13.22 2.52997 11.67L2.76997 6.65996C2.87997 4.26996 4.76997 2.37996 7.16997 2.25996L12.17 2.01996C13.73 1.94996 15.24 2.52996 16.34 3.62996L20.87 8.15996C23.02 10.31 23.02 13.82 20.87 15.97L16.48 20.36C15.4 21.44 13.99 21.98 12.57 21.98ZM5.19997 14.77L9.72997 19.3C11.3 20.87 13.85 20.87 15.42 19.3L19.81 14.91C21.38 13.34 21.38 10.79 19.81 9.21996L15.27 4.69996C14.47 3.89996 13.38 3.47996 12.23 3.52996L7.22997 3.76996C5.60997 3.83996 4.33997 5.10996 4.25997 6.72996L4.01997 11.74C3.96997 12.86 4.39997 13.97 5.19997 14.77Z",
  fill: "#2353F5"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  d: "M10 12.75C8.21 12.75 6.75 11.29 6.75 9.5C6.75 7.71 8.21 6.25 10 6.25C11.79 6.25 13.25 7.71 13.25 9.5C13.25 11.29 11.79 12.75 10 12.75ZM10 7.75C9.04 7.75 8.25 8.54 8.25 9.5C8.25 10.46 9.04 11.25 10 11.25C10.96 11.25 11.75 10.46 11.75 9.5C11.75 8.54 10.96 7.75 10 7.75Z",
  fill: "#2353F5"
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("path", {
  d: "M13.4999 17.7499C13.3099 17.7499 13.1199 17.6799 12.9699 17.5299C12.6799 17.2399 12.6799 16.7599 12.9699 16.4699L16.9699 12.4699C17.2599 12.1799 17.7399 12.1799 18.0299 12.4699C18.3199 12.7599 18.3199 13.2399 18.0299 13.5299L14.0299 17.5299C13.8799 17.6799 13.6899 17.7499 13.4999 17.7499Z",
  fill: "#2353F5"
}, null, -1)
const _hoisted_5 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_5))
}
export default { render: render }